import script from "./acme.cert-manager.io.order.vue?vue&type=script&setup=true&lang=ts"
export * from "./acme.cert-manager.io.order.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__